import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import React, { useEffect } from "react";
import CustomPageForm from "./form/index.form";
import { endpoint } from "@services/api.services";
import { ColumnList } from "./column/index.column";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import { useSearchParams } from "react-router";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { CustomPageData } from "@utils/interface/journey.interface";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { ToggleShowCustomPage } from "@services/CustomPageServices";

type Props = {};

const index: React.FC<Props> = ({}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryData<CustomPageData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
    },
    endpoint: endpoint["custompage"],
    key: `${pathname}-listing`,
    window: true,
  });
  // rollback
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const { mutate: toggleActiveStatus } = useMutation({
    mutationFn: ToggleShowCustomPage,
    onSuccess: (response) => {
      refetch();
      // Extract the image URL/ID from the response - adjust based on your API response structure
      toast.success("Successfully updated the Custom page status");
      console.log("The Custom page is_show updated", response);
    },
    onError: (error) => {
      console.error("Ishow update failed", error);
      // setIsUploading(false);
      // Handle error - show toast notification, etc.
    },
  });

  const columns = ColumnList({
    refetch: refetch,
    toggleActiveStatus: toggleActiveStatus,
  });

  return (
    <>
      <TableCard
        bulkActions
        formId={pathname}
        form={<CustomPageForm />}
        table_content={{
          mode: "default",
          type: pathname,
        }}
        showOrientation
        grid={
          <GeneralCard
            isChecked={false}
            type={"faq"}
            content={{
              title: "What kind of courses does Skillshikshya offer?",
              description:
                "Skillshikshya offers a variety of courses designed to enhance skills, covering levels from beginner to advanced. Our course options include UI/UX design, coding, digital marketing, and more!",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        inject_ui_table_actions
        orientationPosition={false}
        columns={columns}
        refetch={refetch}
        endpoint={endpoint["custompage"]}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
        }}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default index;
